import React from "react";
import "./countertop-card.scss";


function CountertopCard(props) {
return (

  
<div className="countertop-card">
        
    <><img src={props.data.imageurl} alt={props.data.altText} />
    <h3>{props.data.productName}</h3>
    {/*  <div className="product-colors">
        <span>Shown in {props.data.productName} finish</span>
        <div className="color-list">
       {props.data.colors ? 
             props.data.colors.map((d,i) => (
            <div key={i} style={{
                backgroundColor: `${d.encodedColor}`
                   }} className="color-name">
                    <div>{d.colorName}</div>
                    </div>
             )
             )
            : 'loading'}
            <div className="more-color">{props.data.moreColors}</div> 
        </div>
    </div>*/}
    </>

</div>
);
}

export default CountertopCard;